import React, { Component, Fragment } from 'react'
import inventoryCaseApi, {
  CaseData, CaseTransferQuantityRequest
} from '../../apis/inventoryCase.api'
import alertService from '../../services/alert.service'
import confirmService from '../../services/confirm.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import CardButton from '../../components/CardButton'
import InputText from '../../components/InputText'
import Row from '../../components/Row/Row'
import InputScan from '../../components/InputScan'
import { i18n } from "../../i18n/i18n";

interface Props {
  onSourceCaseChange: (sourceCase: CaseData | null) => void
  onResetForm: () => void
}

interface State {
  sourceCaseCode: string
  targetCaseCode: string
  quantity: string
  sourceCase: CaseData | null
  targetCase: CaseData | null
}

export default class TransferToCase extends Component<Props, State> {
  initialState: State = {
    sourceCaseCode: '',
    targetCaseCode: '',
    quantity: '',
    sourceCase: null,
    targetCase: null
  }

  constructor (props: Props) {
    super(props)
    this.state = this.initialState
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleInputScan = this.handleInputScan.bind(this)
    this.handleTransferClick = this.handleTransferClick.bind(this)
  }

  readSourceCase (code: string) {
    if (!code) return
    inventoryCaseApi.readByCode(code, sourceCase => {
      this.setState({ sourceCase })
      this.props.onSourceCaseChange(sourceCase)
    })
  }

  readTargetCase (code: string) {
    if (!code) return
    inventoryCaseApi.readByCode(code, targetCase => {
      this.setState({ targetCase })
    })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'sourceCaseCode') {
      this.setState({ sourceCaseCode: value })
    } else if (name === 'targetCaseCode') {
      this.setState({ targetCaseCode: value })
    } else if (name === 'quantity') this.setState({ quantity: value })
  }

  handleInputScan (name: string, value: string) {
    if (name === 'sourceCaseCode') {
      this.readSourceCase(value)
    } else if (name === 'targetCaseCode') {
      this.readTargetCase(value)
    }
  }

  reset () {
    this.setState(this.initialState)
    this.props.onResetForm()
  }

  handleTransferConfirm () {
    const { sourceCase, targetCase, quantity } = this.state
    const payload: CaseTransferQuantityRequest = {}
    if (sourceCase) payload.sourceCase = sourceCase.id
    if (targetCase) payload.targetCase = targetCase.id
    if (quantity) payload.quantity = Number(quantity)
    inventoryCaseApi.transferQuantity(payload, inventoryCase => {
      if (!inventoryCase) return
      alertService.success('Successfully transferred')
      this.reset()
    })
  }

  handleTransferClick () {
    const confirm: ConfirmParams = {
      id: 1,
      question: i18n('Please review and confirm transfer.'),
      confirmText: i18n('Confirm'),
      cancelText: i18n('Cancel'),
      onConfirm: () => this.handleTransferConfirm()
    }
    confirmService.push(confirm)
  }

  render () {
    return (
      <Fragment>
        <Row column={2}>
          <InputScan
            name="sourceCaseCode"
            value={this.state.sourceCaseCode}
            label={i18n("Scan source case code")}
            autofocus={true}
            onChange={this.handleInputChange}
            onScan={this.handleInputScan} />
          <InputScan
            name="targetCaseCode"
            value={this.state.targetCaseCode}
            label={i18n("Scan target case code")}
            onChange={this.handleInputChange}
            onScan={this.handleInputScan} />
          <InputText
            name="quantity"
            value={this.state.quantity}
            label={i18n("Quantity")}
            onChange={this.handleInputChange} />
        </Row>
        <CardButton
          proceedText={i18n("Transfer")}
          onProceedClick={this.handleTransferClick} />
      </Fragment>
    )
  }
}
